import * as React from 'react';
import { Icon } from '@wix/answers-ui-libby';
import { classNames } from '@wix/answers-lib';
import { searchQuestionIcon } from './search-question-icon';
export const QuestionComponent = (props) => {
    const { question } = props.value;
    // Construct the Wix support search URL with the question as the search term
    const searchUrl = `https://support.wix.com/${props.locale}/search?term=${encodeURIComponent(question)}`;
    const handleQuestionClick = () => {
        if (props.onQuestionClick) {
            props.onQuestionClick(props.value);
        }
    };
    return (React.createElement("div", { className: classNames('component', 'question-component'), "data-component-type": 'question' },
        React.createElement("div", { className: 'search-icon' },
            React.createElement(Icon, { icon: searchQuestionIcon })),
        React.createElement("a", { href: searchUrl, className: 'question-link', target: "_self", rel: "noopener noreferrer", onClick: handleQuestionClick }, question)));
};
